import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { ItemApi } from 'src/features/common/item/item-api';
import { CallLogContact } from 'src/cad/administration/call-log/shared/interfaces/call-log-contact';
import ValidationResult = cad.ValidationResult;
import { isNil } from 'lodash';

@Injectable()
export class ContactMaintenanceApi extends ItemApi {

  private readonly endpoint: string = 'administration/calllog/maintenance/contact';
  
  constructor(
    public apiHelper: ApiHelper
  ) {
    super();
  }
  
  public getById(callLogContactId: number): Observable<CallLogContact> {
    return this.apiHelper.request(this.endpoint + '/' + callLogContactId);
  }
  
  public find(filterData: CallLogContact): Observable<CallLogContact> {
    if (filterData && !isNil(filterData.callLogContactId)) {
      return this.getById(filterData.callLogContactId);
    } else {
      throw new Error('callLogContactId is invalid.');
    }
  }
  
  public filter(filterData: Partial<CallLogContact>): Observable<CallLogContact[]> {
    return this.apiHelper.request(`${ this.endpoint }/filter`, { body: filterData });
  }
  
  public recent(): Observable<CallLogContact[]> {
    return this.apiHelper.request(`${ this.endpoint }/dashboard`);
  }
  
  public save(saveData: CallLogContact): Observable<ValidationResult<CallLogContact>> {
    return this.apiHelper.request(`${ this.endpoint }/save`, { body: saveData });
  }
  
  public deleteItem(deleteData: CallLogContact): Observable<ValidationResult> {
    throw new Error('Method not implemented.');
  }
}
